<ng-container>
  <front-header [content]="'RSE'"/>

  <div class="rse-container">
    <div [renderHtml]="'RSE description'"></div>
  </div>
</ng-container>
